function TitreI2C() {
  return (
    <div className="px-6 font-extrabold text-center text-[40px]">
      <span className="text-bleu-je">I</span>
      <span className="text-gris-sombre dark:text-blanc-sombre">ngénierie et </span>
      <span className="text-bleu-je">C</span>
      <span className="text-gris-sombre dark:text-blanc-sombre">onseil en </span>
      <span className="text-bleu-je">C</span>
      <span className="text-gris-sombre dark:text-blanc-sombre">ognitique</span>
    </div>
  );
}

export default TitreI2C;